import React, { useState } from 'react'
import { Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { resyncTreeGraph } from '../../services/treeGraphService'
import useNotifications from '../../hooks/useNotifications'

export default function ResyncTreeGraph({ sourceIds, destinationIds, validIds }) {
  const { t } = useTranslation()
  const { ok, error } = useNotifications()

  const ids = [...sourceIds, ...destinationIds].filter((id) => id)
  const [disabled, setDisabled] = useState(false)

  const handleResync = async () => {
    let failedIds = []
    try {
      setDisabled(true)
      failedIds = await Promise.all(
        ids
          .map((id) => {
            resyncTreeGraph(id).catch(() => {
              return id
            })
            return null
          })
          .filter((id) => id)
      )
      if (failedIds.length === 0) {
        ok(t('relationship.calculator.successResync', 'Request to re-sync with Family Tree submitted'))
      } else {
        error(
          t(
            'relationship.calculator.errorResyncing',
            'Error submitting Family Tree re-sync request for IDs {failedIds}',
            {
              failedIds: failedIds.join(', '),
            }
          )
        )
      }
    } finally {
      setDisabled(false)
    }
  }

  return (
    <Button emphasis="medium" onClick={handleResync} disabled={disabled || !(validIds.left || validIds.right)}>
      {t('resyncTreeGraph', 'Resync Tree Graph')}
    </Button>
  )
}
